import { useEffect, useState } from 'react';
import { Navigate,useParams }    from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import AddPostForm    from '@/shared-components/forms/add-board-content/add-post/index';  // your AddPostForm import
import Loader from '@/shared-components/loader/Loader';
import { canAccessGalleryPermission } from '@/utils/galleryPermissions';

export default function EditPost() {
  const { postId } = useParams();
  const [postData, setPostData] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const { state } = useStateHandler();
  const session = state.user_session;
  const sessionType = String(session?.user_type ?? session?.__t ?? "").toLowerCase();
  const canEditPost = sessionType === "artist"
    || !session?.gallery_id
    || canAccessGalleryPermission(session, "board.post", session?.gallery_id);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const { data } = await GalleryService.getPostById(postId);
        if (isMounted) setPostData(data);
      } catch (err) {
        console.error("Failed to load post for editing", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, [postId]);

  if (!canEditPost) return <Navigate to="/profile/board" replace />;
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Loader />
    </div>
  ); 
  if (!postData) return <Navigate to="/profile/board" replace />;

  // **Now** we have the real postData, pass it in:
  return <AddPostForm postData={postData} editMode />;
}
